import { render, staticRenderFns } from "./MessagesTicket.vue?vue&type=template&id=ffb04cae&"
import script from "./MessagesTicket.vue?vue&type=script&lang=js&"
export * from "./MessagesTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports